import { useQuery } from '@tanstack/react-query';
import { get } from '@xmatters/redux/services/httpService';

export default function useGetForm({ formUuid }) {
  const uri = `/api/xm/1/forms/${formUuid}`;
  return useQuery({
    enabled: !!formUuid,
    queryKey: ['form', formUuid],
    queryFn: () => get({ uri }),
    cacheTime: 1,
  });
}
